<template>
  <div class="uploader">
    <slot :files="files" :file-list="fileList" :started="started">
      <uploader-unsupport></uploader-unsupport>
      <uploader-btn :type="type"><i class="el-icon-upload" v-if="type !== 'text'"></i>&nbsp;{{uploadBtnText}}</uploader-btn>
      <slot name="append"/>
      <!--<uploader-btn :directory="true">选择目录</uploader-btn>-->
      <uploader-list></uploader-list>
    </slot>
  </div>
</template>

<script>
  import Uploader from 'simple-uploader.js'
  import Emitter from '../common/emitter.js'
  import extend from '../common/extend.js'
  import { kebabCase, formatSize } from '../common/utils'
  import UploaderBtn from './btn.vue'
  import UploaderDrop from './drop.vue'
  import UploaderUnsupport from './unsupport.vue'
  import UploaderList from './list.vue'
  import UploaderFiles from './files.vue'
  import UploaderFile from './file.vue'
  import VFile from '../common/v-file.js'

  const COMPONENT_NAME = 'uploader'
  const FILE_ADDED_EVENT = 'fileAdded'
  const FILES_ADDED_EVENT = 'filesAdded'
  const UPLOAD_START_EVENT = 'uploadStart'

  export default {
    name: COMPONENT_NAME,
    provide () {
      return {
        uploader: this
      }
    },
    props: {
      options: {
        type: Object,
        default () {
          return {}
        }
      },
      autoStart: {
        type: Boolean,
        default: true
      },
      value: {
        type: Array,
        default () {
          return []
        }
      },
      fileStatusText: {
        type: Object,
        default () {
          return {
            success: '上传成功',
            error: '上传失败',
            uploading: '上传中',
            paused: '暂停',
            waiting: '等待上传'
          }
        }
      },
      sizeLimit: {
        type: Number,
        default: 0
      },
      typeLimit: {
        type: Array,
        default () {
          return []
        }
      },
      limit: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: 'btn'
      },
      uploadBtnText: {
        type: String,
        default: '上传文件'
      }
    },
    watch: {
      value: {
        immediate: true,
        deep: true,
        handler () {
          this.__init()
        }
      }
    },
    data () {
      return {
        started: false,
        files: [],
        fileList: [],
        emitter: null,
        currentFileArray: [],
        init: false
      }
    },
    beforeMount () {
      // this.currentFileArray = this.value
      // let value = this.generateVirtualFiles(this.value)
      // if (this.fileList.length > 0) {
      //   this.fileList = [...value, ...this.fileList]
      // } else this.fileList = value
      this.emitter = new Emitter()
      this.emitter.on('removeFile', this.removeVirtualFile)
    },
    methods: {
      isUploading () {
        return this.uploader.isUploading()
      },
      __init () {
        let value = this.generateVirtualFiles(this.value)
        if (this.fileList.length === 0) {
          this.currentFileArray = value
          this.fileList = value
          // 初始化完成
          this.init = true
        }
      },
      processResponse (response, cb) {
        try {
          if (response && typeof response === 'string') {
            let res = JSON.parse(response)
            let identifier = res.data.identifier
            if (identifier) {
              let index = this.fileList.findIndex(file => file.uniqueIdentifier === identifier)
              if (index !== -1 && res.data.fileInformation) {
                this.fileList[index].id = res.data.fileInformation.id
                this.fileList[index].url = res.data.url
                // this.$emit('file-change', this.fileList)
                this.$emit('input', this.fileList)
              }
            }
          }
        } catch (err) {
          console.error(err)
          cb()
        }
        return cb()
      },
      onPreprocess (file) {
        if (this.limit && this.currentFileArray.length >= this.limit) {
          // 超出文件数量限制
          this.$emit('on-exceed', this.fileList)
          return true
        }
        // 获取文件类型（不精确）
        let ext = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : ''
        if (ext) ext = ext.toLowerCase()
        let typeError = this.typeLimit.length > 0
        for (let i = 0; i < this.typeLimit.length; ++i) {
          let type = this.typeLimit[i]
          if (type.toLowerCase() === ext) {
            typeError = false
            break
          }
        }
        if (typeError) {
          this.$emit('type-error')
          return true
        }
        if (this.sizeLimit <= 0) {
          return false
        } else if (file.size > this.sizeLimit) {
          this.$emit('size-error', `${formatSize(this.sizeLimit)}`, `${formatSize(file.size)}`)
          return true
        }
        return false
      },
      removeVirtualFile (file) {
        let index = this.fileList.findIndex(item => item.id === file.id)
        if (index !== -1) {
          this.fileList.splice(index, 1)
          this.$emit('remove-file', file)
          index = this.currentFileArray.findIndex(item => item.id === file.id)
          if (index !== -1) this.currentFileArray.splice(index, 1)
          // this.$emit('file-change', this.fileList)
          this.$emit('input', this.fileList)
        }
      },
      generateVirtualFiles (val) {
        let value = []
        val.forEach(v => {
          if (this.fileList.findIndex(file => file.id === v.id) === -1) {
            let file = new VFile(v.id, v.name, v.isFolder, v.size)
            value.push(file)
          }
        })
        return value
      },
      uploadStart () {
        this.started = true
      },
      fileAdded (file) {
        file.ignored = this.onPreprocess(file)
        this.$emit(kebabCase(FILE_ADDED_EVENT), file)
        if (file.ignored) {
          // is ignored, filter it
          return false
        }
      },
      filesAdded (files, fileList) {
        if (this.limit && files.length + this.fileList.length > this.limit) {
          this.$emit('on-exceed', this.fileList)
          return false
        }
        this.$emit(kebabCase(FILES_ADDED_EVENT), files, fileList)
        if (files.ignored || fileList.ignored) {
          // is ignored, filter it
          return false
        }
      },
      fileRemoved (file) {
        let index = this.currentFileArray.findIndex(item => item.id === file.id)
        if (index !== -1) {
          this.currentFileArray.splice(index, 1)
        }
        this.fileList = this.currentFileArray
        this.$emit('input', this.currentFileArray)
      },
      filesSubmitted (files, fileList) {
        this.files = this.uploader.files
        let value = []
        // 找出可能不存在的文件
        this.currentFileArray.forEach(file => {
          let index = this.uploader.fileList.findIndex(ii => ii.id === file.id)
          if (index === -1) value.push(file)
        })
        this.fileList = [...value, ...this.uploader.fileList]
        this.currentFileArray = this.fileList
        if (this.autoStart) {
          this.uploader.upload()
        }
      },
      allEvent (...args) {
        const name = args[0]
        const EVENTSMAP = {
          [FILE_ADDED_EVENT]: true,
          [FILES_ADDED_EVENT]: true,
          [UPLOAD_START_EVENT]: 'uploadStart'
        }
        const handler = EVENTSMAP[name]
        if (handler) {
          if (handler === true) {
            return
          }
          this[handler].apply(this, args.slice(1))
        }
        args[0] = kebabCase(name)
        this.$emit.apply(this, args)
      },
      removeAll () {
        this.uploader.cancel()
      }
    },
    created () {
      let defaultOptions = {
        processResponse: this.processResponse,
        singleFile: this.limit === 1,
        generateUniqueIdentifier (file) { // 不要移除中文
          let relativePath = file.relativePath || file.webkitRelativePath || file.fileName || file.name
          return file.size + '-' + relativePath.replace(/[^\u4e00-\u9fa50-9a-zA-Z_-]/img, '')
        },
        simultaneousUploads: 1 // 最大并发数
      }
      this.options.initialPaused = !this.autoStart
      const uploader = new Uploader(extend({}, defaultOptions, this.options))
      this.uploader = uploader
      this.uploader.fileStatusText = this.fileStatusText
      uploader.on('catchAll', this.allEvent)
      uploader.on(FILE_ADDED_EVENT, this.fileAdded)
      uploader.on(FILES_ADDED_EVENT, this.filesAdded)
      uploader.on('fileRemoved', this.fileRemoved)
      uploader.on('filesSubmitted', this.filesSubmitted)
    },
    destroyed () {
      const uploader = this.uploader
      uploader.off('catchAll', this.allEvent)
      uploader.off(FILE_ADDED_EVENT, this.fileAdded)
      uploader.off(FILES_ADDED_EVENT, this.filesAdded)
      uploader.off('fileRemoved', this.fileRemoved)
      uploader.off('filesSubmitted', this.filesSubmitted)
      uploader.cancel()
      this.uploader = null
    },
    components: {
      UploaderBtn,
      UploaderDrop,
      UploaderUnsupport,
      UploaderList,
      UploaderFiles,
      UploaderFile
    }
  }
</script>

<style>
  .uploader {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/uploader/components/uploader.vue